import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useToast } from '../context/ToastContext';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const { addToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      addToast('Please enter your email address.', 'error');
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setSent(true);
      addToast(data.message, 'success');
    } catch (err) {
      addToast(err.message, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-hero">
        <div className="auth-hero-content">
          <img src="/rivitlogo.svg" alt="Rivit" className="auth-hero-logo-img" />
          <h1>Migration Suite</h1>
          <p>A secure client portal by Rivit Technology Partners. Upload your Lotus Notes DXL exports, and our team will deliver detailed migration analysis and readiness reports — all within a protected, encrypted environment.</p>
          <div className="auth-hero-features">
            <div className="auth-hero-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              <span>Secure &amp; Encrypted Uploads</span>
            </div>
            <div className="auth-hero-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
              <span>Automated DXL Analysis</span>
            </div>
            <div className="auth-hero-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              <span>Migration Readiness Reports</span>
            </div>
            <div className="auth-hero-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <span>Confidential &amp; Client-Only Access</span>
            </div>
          </div>
        </div>
      </div>
      <div className="auth-form-panel">
        <div className="auth-form-container">
          <h2>Forgot Password</h2>
          {!sent ? (
            <>
              <p className="auth-subtitle">Enter your email address and we'll send you a link to reset your password.</p>
              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-card">
                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      id="email"
                      type="email"
                      placeholder="you@company.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="email"
                      autoFocus
                    />
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-full" disabled={submitting}>
                  {submitting ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>
            </>
          ) : (
            <div className="reset-sent-message">
              <div className="reset-sent-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <h3>Check Your Email</h3>
              <p className="auth-subtitle">
                If an account exists for <strong>{email}</strong>, we've sent a password reset link.
                Please check your inbox and spam folder.
              </p>
              <p className="auth-subtitle" style={{ marginTop: '0.75rem', fontSize: '0.85rem', color: '#64748b' }}>
                The link will expire in 1 hour.
              </p>
            </div>
          )}
          <p className="auth-switch">
            <Link to="/">← Back to Sign In</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
